import { c as _c } from "react/compiler-runtime";
import Link from "@/components/common/link/link";
import css from "./product-article-card.module.scss";
import ArrowIcon from "@/components/common/arrow-icon/arrow-icon";
import Image from "@/components/common/image/image";
import { addQueryParams } from "@/utilities/url";
import CurvedUnderline from "@/components/common/curved-underline/curved-underline";
import { truncateTextToLines } from "@/utilities/truncateData";
import { ImageLoading } from "@/utilities/imageLoading";
import { dateWithComma } from "@/utilities/date";
export interface IProductArticleProps {
  articleUrl: string;
  articleUrlText?: string;
  category?: string;
  description?: string;
  imageLoading?: ImageLoading;
  imageUrl?: string;
  readMinutes?: number;
  title?: string;
  categoryFrom?: string;
  updatedDate?: string;
}
const ProductArticleCard = props => {
  const $ = _c(40);
  const {
    articleUrl,
    articleUrlText,
    category,
    categoryFrom,
    description,
    imageLoading: t0,
    imageUrl,
    title,
    readMinutes: t1
  } = props;
  const imageLoading = t0 === undefined ? ImageLoading.LAZY : t0;
  const readMinutes = t1 === undefined ? 0 : t1;
  const t2 = `${categoryFrom ? "md:pb-0" : "md:pb-10"} group h-full pb-4`;
  const t3 = `${css.productArticleCard} ${categoryFrom ? "!rounded-b-xl !rounded-t-none !border-none !bg-[#F6F6F6] !shadow-none" : "!rounded-md border !border-gray-200 !bg-white !shadow-md"}`;
  let t4;
  if ($[0] !== categoryFrom || $[1] !== imageLoading || $[2] !== imageUrl || $[3] !== title) {
    t4 = imageUrl && <Image className={`${css.productArticleCardImage} ${categoryFrom ? "!rounded-b-none !rounded-t-xl" : "!rounded-md"}`} src={addQueryParams(imageUrl, {
      w: 640
    })} alt={title ?? "article"} width={2560} height={1707} srcSet={`${addQueryParams(imageUrl, {
      w: 1120
    })} 1120w, ${addQueryParams(imageUrl, {
      w: 640
    })} 640w`} sizes="(width <= 768px) 1120px, 640px" loading={imageLoading} />;
    $[0] = categoryFrom;
    $[1] = imageLoading;
    $[2] = imageUrl;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${css.productArticleCardContent} ${categoryFrom ? "!gap-4 !pb-4 md:!pb-16" : "!pr-4 !pt-4 pb-16"}`;
  let t6;
  if ($[5] !== category || $[6] !== categoryFrom || $[7] !== props.updatedDate || $[8] !== readMinutes) {
    t6 = !categoryFrom && <div className={css.productArticleCardInfo}><span className={css.productArticleCardInfoCategory}>{category ?? "Uncategorized"}</span><span>|</span><span className={css.productArticleCardInfoDate}>{dateWithComma(props?.updatedDate ?? "")}</span>{readMinutes > 0 && <><span>|</span><span className={css.productArticleCardInfoReadTime}>{readMinutes} min read</span></>}</div>;
    $[5] = category;
    $[6] = categoryFrom;
    $[7] = props.updatedDate;
    $[8] = readMinutes;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== categoryFrom || $[11] !== title) {
    t7 = title && <h3 className={`${css.productArticleCardTitle} ${categoryFrom ? "!text-xl leading-[26px]" : ""}`}>{title}</h3>;
    $[10] = categoryFrom;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `${css.productArticleCardDescription} ${categoryFrom ? "!text-base font-medium" : ""}`;
  const t9 = description || "";
  let t10;
  if ($[13] !== t9) {
    t10 = truncateTextToLines(t9);
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8) {
    t11 = <p className={t8}>{t10}</p>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== categoryFrom || $[19] !== props.updatedDate || $[20] !== readMinutes) {
    t12 = categoryFrom && <div className={`${css.productArticleCardInfo} bottom-4 flex !text-xs md:absolute md:!text-base`}><span className={css.productArticleCardInfoDate}>{dateWithComma(props?.updatedDate ?? "")}</span>{readMinutes > 0 && <><span>|</span><span className={css.productArticleCardInfoReadTime}>{readMinutes} min read</span></>}</div>;
    $[18] = categoryFrom;
    $[19] = props.updatedDate;
    $[20] = readMinutes;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== articleUrlText || $[23] !== categoryFrom) {
    t13 = !categoryFrom && <div className={`${css.productArticleCardLink} flex items-center font-semibold`}><span>{articleUrlText ?? "Learn More"}</span><ArrowIcon /><CurvedUnderline /></div>;
    $[22] = articleUrlText;
    $[23] = categoryFrom;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7) {
    t14 = <div className={t5}>{t6}{t7}{t11}{t12}{t13}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t3 || $[34] !== t4) {
    t15 = <div className={t3}>{t4}{t14}</div>;
    $[32] = t14;
    $[33] = t3;
    $[34] = t4;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== articleUrl || $[37] !== t15 || $[38] !== t2) {
    t16 = <Link href={articleUrl} className={t2} data-card-link="true">{t15}</Link>;
    $[36] = articleUrl;
    $[37] = t15;
    $[38] = t2;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};
export default ProductArticleCard;